<template>
  <section class="section is-marginless">
    <div class="columns is-centered">
      <div class="column is-half">
        <h3 class="title">Onboard Company</h3>
        <h3 class="subtitle">Please fill out the following information</h3>
        <section v-if="eventHistory.length" class="mt-3 mb-5">
          <h4 class="subtitle has-text-weight-bold">Event History</h4>
          <b-message type="is-info" >
            <ul ref="eventHistoryHeader" tabindex="-1" class="is-info" style="list-style-type: disc">
              <li v-for="event in eventHistory" :key="event" class="is-size-6 mb-1 mt-1">
                {{ event }}
              </li>
            </ul>
          </b-message>
        </section>

        <section v-if="errors.length" class="mt-3 mb-5">
          <h4 class="subtitle has-text-weight-bold">Errors</h4>
          <b-message type="is-danger" >
            <ul ref="errorHeader" tabindex="-1" class="is-danger" style="list-style-type: disc">

              <li v-for="error in errors" :key="error" class="is-size-6 mb-1 mt-1">
                {{ error }}
              </li>
            </ul>
          </b-message>
        </section>
      </div>
    </div>

    <div class="columns is-centered">
      <div class="column is-half">
        <b-field label="WMC Onboard Username">
          <b-input size="is-medium" type="email" icon-pack="fas" icon="envelope" placeholder="WMC Email" ref="wmcUser"
                   v-model="onboard.wmcUser"></b-input>
        </b-field>
      </div>
    </div>

    <div class="columns is-centered">
      <div class="column is-half">
        <b-field label="WMC Admin">
          <b-input size="is-medium" type="email" icon-pack="fas" icon="envelope" placeholder="WMC Admin Username"
                   ref="wmcAdmin" v-model="onboard.wmcAdmin"></b-input>
        </b-field>
      </div>
    </div>

    <div class="columns is-centered">
      <div class="column is-half">
        <b-field label="WMC Admin Password">
          <b-input type="password" size="is-medium" placeholder="WMC Admin Password" ref="wmcAdminPass"
                   v-model="onboard.wmcAdminPass" password-reveal icon-pack="fas" icon="lock"
                   icon-right="close-circle"></b-input>
        </b-field>
      </div>
    </div>

    <div class="columns is-centered">
      <div class="column is-half">
        <b-field label="Dispatch Domain">
          <b-input size="is-medium" icon-pack="fas" icon="globe" placeholder="Dispatch Domain" ref="dispatchDomain"
                   v-model="onboard.dispatchDomain"></b-input>
        </b-field>
      </div>
    </div>

    <div class="columns is-centered">
      <div class="column is-half">
        <b-field label="Dispatch Phone">
          <b-input size="is-medium" type="tel" placeholder="Dispatch Phone" icon-pack="fas" icon="phone"
                   ref="dispatchPickupPhone" v-model="onboard.dispatchPickupPhone"></b-input>
        </b-field>
      </div>
    </div>

    <div class="columns is-centered">
      <div class="column is-half">
        <b-field label="Dispatch Address">
          <b-input size="is-medium" icon-pack="fas" icon="map-marker" placeholder="Dispatch Address"
                   ref="dispatchPickupAddress" v-model="onboard.dispatchPickupAddress"></b-input>
        </b-field>
      </div>
    </div>

    <div class="columns is-centered">
      <div class="column is-half">
        <b-field label="Treez API Key">
          <b-input size="is-medium" type="password" password-reveal icon-pack="fas" icon-right="close-circle" icon="key"
                   placeholder="Treez API Key" ref="treezAPIKey" v-model="onboard.treezAPIKey"></b-input>
        </b-field>
      </div>
    </div>

    <div class="columns is-centered">
      <div class="column is-half">
        <b-field label="Treez Dispensary Name">
          <b-input size="is-medium" icon-pack="fas" icon="building" placeholder="Treez Dispensary Name"
                   ref="treezDispensaryName" v-model="onboard.treezDispensaryName"></b-input>
        </b-field>
      </div>
    </div>

    <div class="columns is-centered">
      <div class="column is-half">
        <b-field label="Metrc" message="Enables METRC for company">
          <b-checkbox v-model="onboard.metrc">
            Metrc
          </b-checkbox>
        </b-field>
      </div>
    </div>

    <div class="columns is-centered">
      <div class="column is-half">
        <b-field label="Metrc Client Key">
          <b-input :disabled="onboard.metrc === false" size="is-medium" placeholder="Metrc Client Key"
                   ref="metrcClientKey" v-model="onboard.metrcClientKey" password-reveal icon-pack="fas"
                   icon-right="close-circle" icon="key"></b-input>
        </b-field>
      </div>
    </div>

    <div class="columns is-centered">
      <div class="column is-half">
        <b-field label="Metrc Recreational License">
          <b-input :disabled="onboard.metrc === false" size="is-medium" placeholder="Metrc Recreational License"
                   ref="recreationLicense" v-model="onboard.recreationLicense" icon-pack="fas" icon="id-card"></b-input>
        </b-field>
      </div>
    </div>

    <div class="columns is-centered">
      <div class="column is-half">
        <b-field label="Metrc Medical License">
          <b-input :disabled="onboard.metrc === false" size="is-medium" placeholder="Metrc Medical License"
                   ref="medicalLicense" v-model="onboard.medicalLicense" icon-pack="fas" icon="id-card"></b-input>
        </b-field>
      </div>
    </div>

    <div class="columns is-centered">
      <div class="column is-half">
        <b-field label="Metrc State">
          <b-select :disabled="onboard.metrc === false" placeholder="Select a state for METRC" size="is-medium"
                    v-model="onboard.metrcState" ref="metrcState" icon-pack="fas" icon="map-pin">
            <option v-for="option in states_list" :key="option.value" v-bind:value="option.value">
              {{ option.text }}
            </option>
          </b-select>
        </b-field>
      </div>
    </div>

    <div class="columns is-centered">
      <div class="column is-half">
        <a class="button is-medium is-link is-half" @click="send" v-bind:class="{ 'is-loading': is_loading }"
           v-bind:dir="is_loading">Submit</a>
      </div>
    </div>
  </section>
</template>

<script>
import OnboardService from './service'
export default {
  name: 'Onboard',
  computed: {},
  data() {
    return {
      eventHistory: [],
      errors: [],
      onboard: {
        wmcUser: null,
        wmcAdmin: null,
        wmcAdminPass: null,
        dispatchDomain: null,
        dispatchPickupAddress: null,
        dispatchPickupPhone: null,
        treezAPIKey: null,
        treezDispensaryName: null,
        recreationLicense: null,
        medicalLicense: null,
        metrcState: null,
        metrcClientKey: null,
        metrc: false,
        from_domain: this.$route.query.from_domain
      },
      is_loading: false,
      states_list: [
        {text: 'Alabama', value: 'AL'},
        {text: 'Alaska', value: 'AK'},
        {text: 'Arizona', value: 'AZ'},
        {text: 'Arkansas', value: 'AR'},
        {text: 'California', value: 'CA'},
        {text: 'Colorado', value: 'CO'},
        {text: 'Connecticut', value: 'CT'},
        {text: 'Delaware', value: 'DE'},
        {text: 'Florida', value: 'FL'},
        {text: 'Georgia', value: 'GA'},
        {text: 'Hawaii', value: 'HI'},
        {text: 'Iowa', value: 'IA'},
        {text: 'Idaho', value: 'ID'},
        {text: 'Illinois', value: 'IL'},
        {text: 'Indiana', value: 'IN'},
        {text: 'Kansas', value: 'KS'},
        {text: 'Kentucky', value: 'KY'},
        {text: 'Louisiana', value: 'LA'},
        {text: 'Massachusetts', value: 'MA'},
        {text: 'Maryland', value: 'MD'},
        {text: 'Maine', value: 'ME'},
        {text: 'Michigan', value: 'MI'},
        {text: 'Minnesota', value: 'MN'},
        {text: 'Missouri', value: 'MO'},
        {text: 'Mississippi', value: 'MS'},
        {text: 'Montana', value: 'MT'},
        {text: 'North Carolina', value: 'NC'},
        {text: 'North Dakota', value: 'ND'},
        {text: 'Nebraska', value: 'NE'},
        {text: 'New Hampshire', value: 'NH'},
        {text: 'New Jersey', value: 'NJ'},
        {text: 'New Mexico', value: 'NM'},
        {text: 'Nevada', value: 'NV'},
        {text: 'New York', value: 'NY'},
        {text: 'Ohio', value: 'OH'},
        {text: 'Oklahoma', value: 'OK'},
        {text: 'Oregon', value: 'OR'},
        {text: 'Pennsylvania', value: 'PA'},
        {text: 'Rhode Island', value: 'RI'},
        {text: 'South Carolina', value: 'SC'},
        {text: 'South Dakota', value: 'SD'},
        {text: 'Tennessee', value: 'TN'},
        {text: 'Texas', value: 'TX'},
        {text: 'Utah', value: 'UT'},
        {text: 'Virginia', value: 'VA'},
        {text: 'Vermont', value: 'VT'},
        {text: 'Washington', value: 'WA'},
        {text: 'Wisconsin', value: 'WI'},
        {text: 'West Virginia', value: 'WV'},
        {text: 'Wyoming', value: 'WY'}
      ],
    }
  },

  mounted() {
    this.$refs.wmcUser.focus()
  },

  methods: {

    send() {
      this.is_loading = true;
      this.errors = []

      if (!this.metrc) {
        this.recreationLicense = null
        this.medicalLicense = null
        this.metrcState = null
        this.metrcClientKey = null
      }

      if (!this.onboard.wmcUser) {
        this.$refs.wmcUser.focus()
        this.errors.push('Please enter the WMC user email')
      }

      this.errors.wmcUser = null

      if (!this.onboard.wmcAdmin) {
        this.errors.push('Please enter the WMC admin email')
      }

      if (!this.onboard.wmcAdminPass) {
        this.errors.push('Please enter the WMC admin password')
      }

      if (!this.onboard.dispatchDomain) {
        this.errors.push('Please enter the dispatch domain')
      }

      if (!this.onboard.treezAPIKey) {
        this.errors.push('Please enter the Treez API key')
      }

      if (!this.onboard.treezDispensaryName) {
        this.errors.push('Please enter the Treez Dispensary Name')
      }

      if (this.onboard.metrc === 1) {
        if (!this.onboard.recreationLicense) {
          this.errors.push('Please enter the Recreation License')
        }

        if (!this.onboard.medicalLicense) {
          this.errors.push('Please enter the Medical License')
        }

        if (!this.onboard.metrcClientKey) {
          this.$refs.metrcClientKey.focus()
          this.errors.push('Please enter the Metrc Client Key')
        }

        if (!this.onboard.metrcState) {
          this.$refs.metrcState.focus()
          this.errors.push('Please select state')
        }
      }

      if (this.errors.length > 0) {
        this.is_loading = false;
        this.$nextTick(() => {
          this.$refs.errorHeader.focus()
        })
        return;
      }

      OnboardService.send(this.onboard, (err, onboardResult) => {
        this.is_loading = false;
        this.errors = []

        if (err) {
          this.errors.push(err.message)
          this.$nextTick(() => {
            this.$refs.errorHeader.focus()
          })
          return;
        }

        if (onboardResult.error) {
          this.errors.push(onboardResult.error)
          this.eventHistory = onboardResult.eventHistory
          this.$nextTick(() => {
            this.$refs.errorHeader.focus()
          })
          return;
        }

        this.$router.push({name: 'OnboardSuccess'})
      })

    },

    throwError(message) {
      this.is_loading = false;
      this.errors.push(message)
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/onboard/Onboard.vue